<template>
  <generic-modal
    :title="$t('file details')"
    :buttons="buttons"
    ref="generic_modal"
  >
    <div>
      <div class="title is-5">
        {{ file.name }}
      </div>
      <div class="subtitle is-6" v-if="file.settings">
        {{ file.settings.mimetype }} |
        {{ translate_file_size(file.settings.size) }}
      </div>
      <div class="field">
        <input
          class="is-checkradio"
          type="checkbox"
          id="chk_is_public"
          v-model="is_public"
        />
        <label for="chk_is_public">{{ $t("is public?") }}</label>
      </div>
      <div class="subtitle is-6" v-if="is_public">
        <a
          :href="`${api_host}/drive/static/${file.settings.final_name}`"
          target="_blank"
          >{{ `${api_host}/drive/static/${file.settings.final_name}` }}</a
        >
        <br />
        <div
          class="button"
          :data-tooltip="$t('copy to clipboard')"
          @click="copy_to_clipboard"
        >
          <span class="icon"><i class="fa fa-copy"></i></span>
        </div>
      </div>
      <!-- <pre>{{ file }}</pre> -->
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p>{{ error }}</p>
    </div>
  </generic-modal>
</template>
<script>
import {
  put,
  api_host,
  get,
  post,
  error_message,
  success_message,
  generate_error_message_text,
  get_currency_settings,
  translate_file_size,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";

export default {
  name: "FileModal",
  components: { GenericModal, GenericUploader },
  data() {
    return {
      api_host,
      buttons: [
        {
          text: this.$t("close"),
          class: "is-rounded",
          icon: "fa fa-close",
          click: this.close_modal,
        },
      ],
      file: {},
      is_public: false,
      error: "",
    };
  },
  computed: {},
  methods: {
    translate_file_size,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(file_uuid) {
      let v = this;
      v.set_initial_state();
      get("/drive/file", { uuid: file_uuid })
        .then((response) => {
          v.file = response;
          v.is_public = response.is_public;
          v.$refs.generic_modal.show_modal();
        })
        .catch((error) => {
          v.error = error_message(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.file = {};
      v.is_public = false;
      v.error = "";
    },
    copy_to_clipboard() {
      let v = this;
      let el = document.createElement("textarea");
      el.value = `${api_host}/drive/static/${v.file.settings.final_name}`;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      success_message(v.$t("copied to clipboard"));
    },
  },
  mounted() {},
  watch: {
    is_public() {
      let v = this;
      post("/drive/file/public", {
        uuid: v.file.uuid,
        is_public: v.is_public,
      })
        .then(() => {
          // console.log("updated");
        })
        .catch((error) => {
          v.error = error_message(error);
        });
    },
  },
};
</script>
<style></style>
